<template>
  <v-container fluid>
    <base-material-card
      color="primary"
      icon="mdi-upload"
      inline
      class="ml-0 px-5 py-4"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          Importar Justificativas IeA
        </div>
      </template>
      <v-alert
        type="info"
        text
        dense
        class="mt-6"
      >
        Campos vazios mantêm os valores já salvos. Os valores importados aparecerão nos próximos relatórios.
        Se houver erros, nenhuma alteração do arquivo será aplicada; o resultado ficará disponível no histórico.
        <a
          id="aie-baixar-modelo"
          href="#"
          @click.prevent="baixarModelo"
        >
          Baixar planilha modelo
        </a>
      </v-alert>
      <v-file-input
        id="aie-arquivo-justificativas"
        v-model="arquivo"
        label="Arquivo de justificativas (.xlsx)"
        accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        outlined
        show-size
        :disabled="loading"
        hint="Até 50 MiB e 20 mil linhas."
        persistent-hint
      />
      <v-alert
        v-if="erro"
        type="error"
        outlined
        dense
        role="alert"
      >
        {{ erro }}
      </v-alert>
      <div class="d-flex justify-end flex-wrap mt-6">
        <v-btn
          text
          class="mr-3"
          :disabled="loading"
          :to="{ name: 'AIE Histórico', query: { tab: 'importacoes' } }"
        >
          Voltar
        </v-btn>
        <v-btn
          id="aie-importar"
          color="green"
          :disabled="!arquivo || loading"
          :loading="loading"
          @click="importar"
        >
          Enviar Importação
        </v-btn>
      </div>
    </base-material-card>
  </v-container>
</template>

<script>
import AieJustificativasService from '@/services/AieJustificativasService';

export default {
  name: 'AieImportar',
  data() {
    return { arquivo: null, loading: false, erro: '', baixandoModelo: false };
  },
  methods: {
    async baixarModelo() {
      if (this.baixandoModelo) return;
      this.baixandoModelo = true;
      try {
        const response = await AieJustificativasService.modelo();
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.download = 'modelo_justificativas_iea.xlsx';
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        this.$toast.error('Não foi possível baixar o modelo. Tente novamente.', '', { position: 'topRight' });
      } finally {
        this.baixandoModelo = false;
      }
    },
    async importar() {
      if (this.loading || !this.arquivo) return;
      this.erro = '';
      if (!/\.xlsx$/i.test(this.arquivo.name) || this.arquivo.size > 50 * 1024 * 1024) {
        this.erro = 'Selecione um arquivo .xlsx de até 50 MiB.';
        return;
      }
      this.loading = true;
      try {
        await AieJustificativasService.importar(this.arquivo);
        this.$toast.success('Importação agendada. Acompanhe o processamento no histórico.', '', { position: 'topRight' });
        this.$router.push({ name: 'AIE Histórico', query: { tab: 'importacoes' } });
      } catch (error) {
        this.erro = error?.response?.data?.erro || error?.data?.erro || 'Não foi possível enviar o arquivo. Tente novamente.';
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
